module.exports = __webpack_public_path__ + "img/8.23901588.jpeg";